/**
 * Normalizes a post from GetPostInfo (or similar) into the NewsFeeds dataList item shape.
 */
export const normalizeNewsFeedPost = (rawPost, sortTypePhase = 1) => {
  if (!rawPost) return null;

  const hasNestedPostInfo =
    rawPost.postInfo?.postId == null &&
    rawPost.postInfo?.postInfo?.postId != null;

  if (hasNestedPostInfo) {
    const { postInfo: nested, ...rest } = rawPost;
    return {
      ...rest,
      postInfo: nested.postInfo,
      __sortTypePhase: sortTypePhase,
    };
  }

  if (rawPost.postId != null && rawPost.postInfo == null) {
    return {
      postInfo: rawPost,
      __sortTypePhase: sortTypePhase,
    };
  }

  return {
    ...rawPost,
    __sortTypePhase: rawPost.__sortTypePhase ?? sortTypePhase,
  };
};

export const prependNewsFeedPost = (prevList, rawPost, sortTypePhase = 1) => {
  const normalized = normalizeNewsFeedPost(rawPost, sortTypePhase);
  if (!normalized?.postInfo?.postId) return prevList || [];

  const postId = normalized.postInfo.postId;
  const filtered = (prevList || []).filter(
    (item) => item?.postInfo?.postId !== postId
  );
  return [normalized, ...filtered];
};
